// extracted by mini-css-extract-plugin
export var cardIcon = "_6q-5";
export var checkboxCard = "_6q-0";
export var checkboxCardSelected = "_6q-4";
export var disabled = "_6q-2";
export var interactive = "_6q-1";
export var outerBorder = "_6q-3";
export var spacerMedium = "_6q-8";
export var spacerSmall = "_6q-7";
export var spacerXsmall = "_6q-6";